
const authLayoutStyles = {
  root: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    height: "100vh",
  },
  rootBox: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flex: "1 1 auto",
    flexDirection: "column",
    // backgroundImage: `url(${AuthBackground})`,
    backgroundSize: "cover",
  },
  container: {
    py: {
      xs: "80px",
      md: "20px",
    },
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    mb: 4,
  },
};
export default authLayoutStyles;
